module.exports = __webpack_public_path__ + "static/images/containers/Schedule/images/halo_bottom.6027fecc.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Schedule/images/halo_bottom.png
// module id = 3251
// module chunks = 11